export let getUserStatus =
    {
        data: {
            "responseHeader": {
                "statusCode": "SUCCESS",
                "clientTransactionId": "2f687b91-c8a1-4c6b-887a-2f4d6cddac92",
                "serverTransactionId": "62904592-8a47-42a0-b209-0e69b4eef313"
            },
            "messageList": [],
            "data": {
                "respCode": 0,
                "respMessage": "Operation successful",
                "flightId": "TCIFE_0179_2025-12-05_IST_LAX",
                "tailNumber": "TCIFE",
                "userIp": "10.128.108.21",
                "userMac": "10:9F:41:D2:CC:27",
                "username": "TK_0179_2025-12-05_IST_LAX_2357380759847_C2",
                "userType": "CHARGED",
                "userSegment": "BC",
                "internetAccessState": "AUTHENTICATED",
                "userQuotaList": [
                    {
                        "userQuotaId": "743",
                        "userQuotaType": "TIME",
                        "userQuotaName": "OBPS Chat One Time User Quota",
                        "remainingQuotaAmount": "78012",
                        "initialQuotaAmount": "79200",
                        "validityEnd": 1765078606000
                    },
                    {
                        "userQuotaId": "741",
                        "userQuotaType": "VOLUME",
                        "userQuotaName": "OBPS Volume One Time User Quota",
                        "remainingQuotaAmount": "1009",
                        "initialQuotaAmount": "1024",
                        "validityEnd": 1765078606000
                    },
                    {
                        "userQuotaId": "741",
                        "userQuotaType": "VOLUME",
                        "userQuotaName": "OBPS Volume One Time User Quota",
                        "remainingQuotaAmount": "250",
                        "initialQuotaAmount": "250",
                        "validityEnd": 1765079195000
                    }
                ]
            },
            "loginStatus": null,
            "jwt": null
        }
    };